import { useState } from "react";
import { useParams } from "react-router-dom";

import RoomsGrid from "./RoomsGrid";
import RoomsSkeleton from "./RoomSkeleton";
import RoomsDrawer from "./RoomsDrawer";

import useFetch from "../../../clients/features/get_withcredentials";
import axios from "axios";

export default function Rooms({ setActivePage }) {

  const hotelParams = useParams();
  const hotelId = hotelParams.hotelId;

  const [opened, setOpened] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);

  const { data, loading, error, refreshData } = useFetch(
    `https://api.komorotel.com/api/hotels/rooms/${hotelId}`
  );

  const openRoom = (room) => {
    setSelectedRoom(room);
    setOpened(true);
  };
  const createRoom = () => {
    setSelectedRoom(null);
    setOpened(true);
    };
    const deleteRoom= async(roomId)=>{
        try{
            axios.delete(`https://api.komorotel.com/api/rooms/${roomId}/${hotelId}`,
                {
                    withCredentials:true
                }
            )
        }catch(err){
            console.error(err)
        }
        refreshData()
        setOpened(false);
    }


  return (

    <div style={{ padding: 30 }}>

      <h2 style={{ marginBottom: 30 }}>
        Chambres
      </h2>

      {loading ? (

        <RoomsSkeleton />

      ) : (

        <RoomsGrid
          rooms={data}
          openRoom={openRoom}
          openCreate={createRoom}
          deleteRoom={deleteRoom}
        />

      )}

      <RoomsDrawer
        open={opened}
        setOpen={setOpened}
        room={selectedRoom}
        refreshRooms={refreshData}
        hotelId={hotelId}
        setActivePage={setActivePage}
      />

    </div>
  );
}